import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DidService } from '../../../services/did/did.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PeersService } from '../../../services/peers/peers.service';
import { UserService } from '../../../services/user/user.service';
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../../toast/toast.component';

export interface DialogData {
    id: any;
}

@Component({
    selector: 'app-edit-dids',
    templateUrl: './edit-dids.component.html',
    styleUrls: ['./edit-dids.component.scss']
})
export class EditDidsComponent implements OnInit {


    formAddDid = new FormGroup({
        redirect: new FormControl('peer'),
        peer: new FormControl('')
    });

    options: any[] = [];
    filteredOptions: Observable<string[]>;

    public direcionamento = 'peer';
    public loading = true;
    public peers = [];
    public usersCrm = [];
    public peer;
    public did;

    constructor(
        public dialogRef: MatDialogRef<EditDidsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public didService: DidService,
        public peersService: PeersService,
        public userService: UserService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.didService.stock().subscribe((res) => {
            this.options = res.dids;
            this.get(()=>{
                this.listPeers(() => {
                    this.listUsersCrm(() => {
                        this.getUserRamal();
                        this.loading = false;
                    })
                });
                
            })
            
        })
    }

    get(callback){
        this.didService.get(this.data.id).subscribe((res)=>{
            this.did = res.did;
            
            if(this.did.redirect == 'peer') {
                this.formAddDid.controls.redirect.setValue(this.did.redirect);
                this.formAddDid.controls.peer.setValue(this.did.redirect_id);
            }
            
            callback();
        })
    }


    listPeers(callback) {
        this.peersService.list().subscribe((res) => {
            this.peers = res.peers;

            callback();
        })
    }

    listUsersCrm(callback) {
        this.userService.listUsersCrm().subscribe((res) => {
            this.usersCrm = res.data;
            callback();
        })

    }

    getUserRamal() {
        this.peers.forEach((peer) => {
            this.usersCrm.forEach((user) => {
                if (peer.user_crm_id == user.id) {
                    peer.label = peer.peer_number + " - " + user.nome;
                }
            })
        })
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    save(){
        let redirect = this.formAddDid.value.redirect;
        let redirect_id = this.formAddDid.value.peer
        this.didService.edit(this.data.id, redirect, redirect_id).subscribe((res)=>{
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg,
                duration: 5000
            });
            this.loading = false;
            if(res.success){
                this.dialogRef.close();
            }
        })
    }

}
